<template>
  <div class="myorder-page">
    <Header />
    <div class="container-myorder">
      <div class="orderlist-section">
        <ul>
         <li v-for="(items, index) in orderhistory" :key="index">
            <div class="oder-details-section">
              <div class="estimate_date">
                 <div class="order_id">{{$t('order_id')}} : {{items.order_id}}</div>
              </div>
              <div class="order_details">
              <span class="order-img">
                <img :src="items.gold_products_details.media_images" v-if="items.gold_products_details.media_images" />
                <img src="../assets/images/thumbnail-default.jpg" v-else />
              </span>
              <span class="order-description">{{items.gold_products_details.description}}
                <h4>{{$t('deliveryestimate')}}</h4>
                <div class="delivered_time">{{getLongFormattedDate(items.record_created_at, "en-IN")}}</div>
                  <span>{{items.message}}</span>
              </span>
             
              <span class="order_cost">₹ {{items.minting_cost}}</span>
              </div>
            </div>
            <div class="orders-detail-block">
              {{$t('trackorder')}}
              <a :href="items.tracking_link">{{items.courier_tracking_id}}</a>
            </div>
          </li>
        </ul>
        <span v-if="!orderhistory.length" class="no_data">{{$t('no_history')}}</span>
      </div>
    </div>
    <div class="loader" v-if="loading">
      <img src="https://cdn.mall91.com/9ca91a3c-b750-4f95-854b-15588473cc97.gif" />
    </div>
  </div>
</template>
<script>
import Header from "../components/Header";
import { toaster, getLongFormattedDate } from "../utils/helper";
export default {
  name: "myorder",
  components: {
    Header
  },
  data() {
    return {
      orderhistory: [],
      loading: false,
    };
  },
  methods:{
    getLongFormattedDate
  },
  mounted() {
     this.loading = !this.loading;
      this.$store
      .dispatch({ type: "myOrdersList" })
      .then(data => {
        this.loading = !this.loading;
        this.orderhistory=data.data
      })
      .catch(err => {
        this.loading = !this.loading;
       toaster(this, this.$t("somethingwentwrong"), "top-left", 2000);
      });
  }

};
</script>